module.exports = __webpack_public_path__ + "img/human-error.9ae74882.jpeg";